<template>
  <div>
    <nav-breadcrumb :menu="[{label: '放款记录'}]"/>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="tableData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
      />
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "LoanRecordList",
      data(){
          return{
            tableData: {
              count: 0,
              data: []
            },
            page: 1,
            pageSize: 20,
            actions: [
            ],
            filters: {
              labelWidth: '150px',
              form: {
                fi__transactionNo:'',
                c__customerName:'',

                t__paymentDate:[],
              },
              columns: [
                {
                  label: '客户姓名',
                  component: 'el-input',
                  field: 'c__customerName',
                },
                {
                  label: '贷款编号',
                  component: 'el-input',
                  field: 'fi__transactionNo',
                },
                {
                  label: '放款日期',
                  component: 'date-range-picker',
                  field: 'pay__payDate',
                  op: ['gteq', 'lteq'],
                },

              ],
              onSubmit:()=>{
                this.page = 1
                this.getData()
              }
            }
          }
          },
      computed:{
        columns: function(){
          return [
            {
              type: 'index'
            },

            {
              label: '客户姓名',
              field: 'c__customerName'
            },
            {
              label: '贷款编号',
              field: 'fi__transactionNo'
            },
            {
              label: '放款金额',
              field: 'pay__totalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '放款日期',
              field: 'pay__payDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              label: '放款方式',
              field: 'pay__channel',
              formatter: function (r,c,v) {
                return Status2CN(v)
              }
            },
            /*{
              label: '申请时间',
              field: 't__applicationDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD hh:mm:ss')
              }
            },*/
            {
              label: '操作',
              opts:[
                {
                  label: '查看',
                  class: 'el-icon-view',
                  clickHandler: (index, row) => {
                    this.$router.push({
                      name: 'LoanRecordView',
                      query: {
                        'transactionId': row.fi__transactionId,
                      }
                    })
                  },
                },



              ]
            }
          ]
        },
        filterParams: {
          get: function() {
            return {
              pageSize: this.pageSize,
              pageOffset: (this.page - 1) * this.pageSize,
              'xlist.sort.dataField': 'pay.payDate',
              'xlist.sort.order': 'desc'
            }
          },
          set:function (newVal) {

          }
        }
      },
      watch: {
        filterParams: function () {
          this.getData()
        },
      },

      mounted() {
        this.getData()
      },
      methods: {
        getData: function () {
          xhr.getFinancingPaymentList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res => {
              try {
                this.tableData = res.data
              } catch (e) {

              }
            })
        },

      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/LoanRecordList.vue